import React from 'react';
import { BoolToString } from 'components';
import { getTableColumns } from 'helpers';


const yesNo = [
  {
    label: 'Yes',
    value: true
  },
  {
    label: 'No',
    value: false
  }
];

const RegStepsColumns = [
  ...getTableColumns(
    [
      ['step', 'string', 'Step #', 'center', true],
      ['description', 'string', 'Description', 'left', true]
    ]
  ),
  {
    name: 'isMandatory',
    type: 'object',
    label: 'Required',
    filterable: true,
    align: 'center',
    options: yesNo,
    renderCell: data => (<BoolToString boolValue={data && data.isMandatory} />),
    exportAsYesNo: true
  },
  {
    name: 'isCountTowards',
    type: 'object',
    label: 'Count Towards',
    filterable: true,
    align: 'center',
    options: yesNo,
    renderCell: data => (<BoolToString boolValue={data && data.isCountTowards} />),
    exportAsYesNo: true
  },
  ...getTableColumns(
    [
      ['stepType', 'string', 'Step Type', 'left', true],
      ['loadTo', 'string', 'Load To', 'left', true]
    ]
  ),
  {
    name: 'isProcessedInFm',
    type: 'object',
    label: 'FM?',
    align: 'center',
    filterable: true,
    options: yesNo,
    renderCell: data => (<BoolToString boolValue={data && data.isProcessedInFm} />),
    exportAsYesNo: true
  },
  {
    name: 'isLoadToCaaers',
    type: 'object',
    label: 'caAERS Load?',
    align: 'center',
    filterable: true,
    options: yesNo,
    renderCell: data => (<BoolToString boolValue={data && data.isLoadToCaaers} />),
    exportAsYesNo: true
  },
  {
    name: 'isSlot',
    type: 'object',
    label: 'Slot?',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isSlot} />),
    options: yesNo,
    exportAsYesNo: true
  },
  {
    name: 'isCmStep',
    type: 'object',
    label: 'Central Monitoring?',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isCmStep} />),
    options: yesNo,
    exportAsYesNo: true
  },
  {
    name: 'isEligibilityReviewStep',
    type: 'object',
    align: 'center',
    label: 'Eligibility Review?',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isEligibilityReviewStep} />),
    options: yesNo,
    exportAsYesNo: true
  },
  ...getTableColumns(
    [
      ['startDate', 'string', 'Start Date', 'center', true],
      ['endDate', 'string', 'End Date', 'center', true]
    ]
  ),
  {
    name: 'minNonReqCred',
    type: 'string',
    align: 'center',
    label: 'Minimum Non-required Credentials',
    filterable: true
  },
  {
    name: 'maxNonReqCred',
    type: 'string',
    align: 'center',
    label: 'Maximum Non-required Credentials',
    filterable: true,
    renderCell: data => data?.maxNonReqCred || '0'
  }
];


export default RegStepsColumns;
